/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Style_Guide_Failed_Events_LabelInputs */

const en_style_guide_failed_events_label = /** @type {(inputs: Style_Guide_Failed_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Failed Events`)
};

const fr_style_guide_failed_events_label = /** @type {(inputs: Style_Guide_Failed_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Evenements echoues`)
};

const de_style_guide_failed_events_label = /** @type {(inputs: Style_Guide_Failed_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fehlgeschlagene Ereignisse`)
};

const it_style_guide_failed_events_label = /** @type {(inputs: Style_Guide_Failed_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventi falliti`)
};

const ru_style_guide_failed_events_label = /** @type {(inputs: Style_Guide_Failed_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Неудачные события`)
};

const es_style_guide_failed_events_label = /** @type {(inputs: Style_Guide_Failed_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos fallidos`)
};

const zh_cn2_style_guide_failed_events_label = /** @type {(inputs: Style_Guide_Failed_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失败事件`)
};

const ja_style_guide_failed_events_label = /** @type {(inputs: Style_Guide_Failed_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`失敗したイベント`)
};

const hi_style_guide_failed_events_label = /** @type {(inputs: Style_Guide_Failed_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`असफल घटनाएँ`)
};

const pt_pt2_style_guide_failed_events_label = /** @type {(inputs: Style_Guide_Failed_Events_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eventos Falhos`)
};

/**
* | output |
* | --- |
* | "Failed Events" |
*
* @param {Style_Guide_Failed_Events_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const style_guide_failed_events_label = /** @type {((inputs?: Style_Guide_Failed_Events_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Style_Guide_Failed_Events_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_style_guide_failed_events_label(inputs)
	if (locale === "de") return de_style_guide_failed_events_label(inputs)
	if (locale === "it") return it_style_guide_failed_events_label(inputs)
	if (locale === "ru") return ru_style_guide_failed_events_label(inputs)
	if (locale === "es") return es_style_guide_failed_events_label(inputs)
	if (locale === "zh-CN") return zh_cn2_style_guide_failed_events_label(inputs)
	if (locale === "ja") return ja_style_guide_failed_events_label(inputs)
	if (locale === "hi") return hi_style_guide_failed_events_label(inputs)
	if (locale === "pt-PT") return pt_pt2_style_guide_failed_events_label(inputs)
	return en_style_guide_failed_events_label(inputs)
});